import React from "react";
import { Box } from "./style";
export default props => {
  return (
    <Box
      status={props.input.value}
      disable={props.disable}
      onClick={() => {
        if (!props.disable) {
          props.input.onChange(!props.input.value);
        }
      }}
    />
  );
};
